import { render } from "./ColorDropdownTreat.vue?vue&type=template&id=8b8f11a2"
import script from "./ColorDropdownTreat.vue?vue&type=script&lang=js"
export * from "./ColorDropdownTreat.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__